import React from "react"
import { Link, navigate } from "gatsby"

const SectionRouteLink = ({ to, ariaLabel, ...props }) => {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';

  const handleNavigate = (e, to) => {
    if (pathname && pathname !== "/") {
      e.stopPropagation()
      e.preventDefault()
      navigate(`/`, { state: { active: props.state?.active }, replace: true})
      // NOTE: ერთი გვერდიდან სხვა გვერდის კონკრეტულ სექციაზე გადასვლა რომ გვინდოდა არასწორედ გადაყავდა, ამიტომ ჯერ რუთ ფეიჯზე ვაბრუნებთ და შემდეგ კონკრეტულ გვერდზე
      setTimeout(() => {
        navigate(`/${to}`, { state: { active: props.state?.active }, replace: true})
      }, 1)
    }
  }

  return (
    <Link
      {...props}
      onClick={e => handleNavigate(e, to)}
      to={to}
      aria-label={ariaLabel}
    >
      {props.children}
    </Link>
  )
}

export default SectionRouteLink